import axios from "axios";

export async function getSignedURL(data) {
  const res = await axios.post(
    `${process.env.REACT_APP_ORIGIN}/api/v1/files/signed-url`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        token: window.localStorage.getItem("authToken"),
      },
    }
  );
  return res.data?.data?.url;
}

export async function uploadFileToS3(file, signedURL, onProgress) {
  const response = await axios.put(signedURL, file, {
    headers: {
      "Content-Type": file.type,
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      if (onProgress) {
        onProgress(percentCompleted);
      }
    },
  });

  console.log("Upload success:", response.status);
}
